<template>
    <row style="margin-top: 0px;" v-if="show">
        <col2>
            <v-chip style="cursor: pointer" @click="toggled = !toggled">{{ description }}</v-chip>
        </col2>
        <col10 v-if="variations.length > 0 && !toggled">
            <button
                v-for="(variation, index) in variations"
                :key="`${type}-${variation[type]}-${index}`"
                type="button"
                class="avatar-option"
                v-show="variation.top"
                @click="updateProp(variation[type])"
            >
                <gravatar
                    :min_width="'100px'"
                    :selected_properties="variation"
                    style="max-width: 75px; pointer-events: none;"
                ></gravatar>
            </button>
        </col10>
    </row>
</template>

<script>
  import Row from "@/components/layout/Row";
  import Gravatar from "@/components/users/Gravatar";
  import Col2 from "@/components/layout/Col2";
  import Col10 from "@/components/layout/Col10";
  export default {
    name: "PropertyChooser",
    data () {
      return {
        toggled: true,
      };
    },
    props: {
      type: {required: true},
      description: {required: true},
      value: {required: true},
      options: {required: true},
      current_properties: {required: false},
    },
    computed: {
      show() {
        if (
          this.type === 'graphic_type'
          && this.current_properties?.clothes !== 'GraphicShirt'
        ) {
          return false;
        }

        return true;
      },
      variations() {
        if (!this.current_properties || !Array.isArray(this.options)) {
          return [];
        }
        const variations = [];
        this.options.forEach(option => {
          const properties = JSON.parse(JSON.stringify(this.current_properties));
          properties[this.type] = option;
          variations.push(properties);
        });
        return variations;
      },
    },
    components: {Col10, Col2, Gravatar, Row},
    methods: {
      updateProp(value) {
        this.toggled = true;
        this.$emit('update_prop', value);
      },
    },
  };
</script>

<style scoped>
.avatar-option {
  border: none;
  background: transparent;
  padding: 0;
  margin: 0 4px 4px 0;
  cursor: pointer;
  float: left;
}
</style>
